export default {
  name: 'About',
  props: {
    msg: String
  }
}